import { isUsMarketHoursUtc } from 'shared';

const MARKET_HOURS_REFETCH_MS = 60_000;

export function marketHoursRefetchInterval(): number | false {
  return isUsMarketHoursUtc(new Date()) ? MARKET_HOURS_REFETCH_MS : false;
}

/** Keeps the previous result on screen while a new key loads, but never across accounts. */
export function keepPreviousDataForAccount(accountId: string | null) {
  return <TData>(
    previousData: TData | undefined,
    previousQuery: { queryKey: readonly unknown[] } | undefined,
  ): TData | undefined => (previousQuery?.queryKey[2] === accountId ? previousData : undefined);
}
